export default "__VITE_ASSET__n3mM0jTr__"